<template>
  <div class="cb-body__wrap">
      <div v-if="placeholder_list == 1" class="cb-placeholder__wrap">
        <cb-placeholder :custom-class="'md rect-sm'"></cb-placeholder>
        <cb-placeholder :custom-class="'st rect-lg'"></cb-placeholder>
        <cb-placeholder :custom-class="'sm'"></cb-placeholder>
        <cb-placeholder :custom-class="'sm'"></cb-placeholder>
      </div>
      <div v-else v-for="(item, index) in placeholder_list" class="cb-placeholder__wrap" v-bind:key="index">
        <div class="cb-placeholder__container">
          <cb-placeholder :custom-class="'sm rect-xl'" class="cb-placeholder__left"></cb-placeholder>
          <cb-placeholder :custom-class="'sm rect-sm'" class="cb-placeholder__right"></cb-placeholder>
        </div>
        <cb-placeholder :custom-class="'md rect-sm'"></cb-placeholder>
      </div>
  </div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import Placeholder from "@/components/collections/elements/Placeholder"
import CBNotification from "@/models/cb-notification"
export default {
  mounted() {
    this.placeholder_list = this.$store.state.order ? this.$store.state.order.cart.orderItems.length : 0;
    //if estimate is loaded quickly, 'cart_items_loaded' in the watch won't work
    if(this.cart_items_loaded) {
      this.$router.replace({name : this.is_cart_with_estimate ? "cart" : "cart_new"});
    }
  },
  data() {
    return {
      placeholder_list: "",
    }
  },
  watch : {
    order_cart_items(newValue, oldValue) {
      if(newValue && newValue.length == 0) {
        this.$store.dispatch('set_current_notification', new CBNotification('error', {message: "No items found"}));
        this.$router.push({
          name: "error"
        });
      }
    },
    cart_items_loaded(newValue, oldValue) {
        if(newValue) {
            this.$router.replace({name : this.is_cart_with_estimate ? "cart" : "cart_new"});
        }
    }
  },
  computed: {
    ...mapGetters([
        'cart_items_loaded',
        'order_cart_items',
        'is_cart_with_estimate'
      ])
  },
  components: {
    'cb-placeholder': Placeholder
  },
  methods: {
    
  }
}
</script>



// WEBPACK FOOTER //
// CartScreen.vue?4940e3f0